import SamiLogo from '../images/sami logo one side.png';
import signature from '../images/sami signature.png';
const About = () => (
  <section className="about-me py-5" id="about">
    <div className="container-md d-flex flex-column flex-md-row align-items-center justify-content-between h-100">
      <div className="left mb-4 mb-md-0">
        <div className="tooltip1" />
        <img
          src={SamiLogo}
          style={{ borderRadius: 5 }}
          className="img-fluid"
          alt="Full Stack Developer"
        />
      </div>
      <div className="right">
        <div className="w-75 mx-auto">
          <span className="mb-3">ABOUT ME</span>
          <h2
            className="text-white mb-5 text-wrap"
            style={{ fontSize: 40, fontWeight: 600 }}
          >
            I Code with Passion & Precision
          </h2>
          <p className="text-white mb-5">
            With extensive experience in full-stack development, I am dedicated to building innovative digital solutions and mentoring aspiring developers. My approach combines technical expertise with practical, real-world applications.
          </p>
          <p className="text-white">
            Whether you're looking to build a web application, learn programming skills, or enhance your development career, I'm here to provide expert guidance and cutting-edge solutions.
          </p>
          <ul className="text-white mb-3 list-unstyled row">
            <div className="col-6">
              <li className='mt-3'>
                <strong className="text-effect">Name</strong> <p>Sami Muuhammad</p>
              </li>
              <li>
                <strong className="text-effect">Phone:</strong> <p>+01025374656</p>
              </li>
              <li>
                <strong className="text-effect">Age:</strong> <p>21 Years</p>
              </li>
            </div>
            <div className="col-6">
              <li className='mt-3'>
                <strong className="text-effect">Email:</strong>
                <p>samielkanasoo4@gmail.com</p>
              </li>
              <li>
                <strong className="text-effect">Occupation:</strong> <p>Full Stack Developer</p>
              </li>
              <li>
                <strong className="text-effect">Nationality:</strong> <p>Egyptian</p>
              </li>
            </div>
          </ul>
          <div className="d-flex justify-content-between mt-5 align-items-center" id='about-signature'>
            <div className="logo p-3 mb-2" >
              <img
                src={signature}
                alt="Signature"
                className=''
                width={250}
              />
            </div>
            <div className="d-flex flex-column flex-md-row gap-3">
              <p style={{ color: "#9b9db1", fontFamily: "cursive" }}>
                Full Stack Developer & Programming Instructor
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;